import React from "react"
import Container from "../components/container"
import ContactLink from "../components/contactlink"
import Copyright from "../components/copyright"
import Footer from "../components/footer"
import Navbar from "../components/navbar"

import amare_logo from "../images/amare_logo.png"
import img_1 from "../images/amare_img_12_v.jpg"
import img_2 from "../images/amare_img_5_h.jpg"
import img_3 from "../images/amare_img_19_v.jpg"
import img_4 from "../images/amare_img_3_h.jpg"

import * as amareStyles from "./amare.module.css"

export default function Amare() {
  return (
    <React.Fragment>
      <Navbar></Navbar>
      <Container>
        <div className={amareStyles.logo}><img src={amare_logo} alt="Amare Logo"/></div>       
        <div className={amareStyles.wrapper}>
          <div>
            <h3 className="text-md-left pb-1">
            <em>O sertão virou mar!</em> Nosso estúdio de estamparia possui foco direcionado para a <em>produção sob demanda</em>, alinhando-se com princípios sustentáveis, reduzindo o desperdício - tanto para a nossa fábrica, quanto para o nosso cliente.
            </h3>
            <h3 className="text-md-left pb-5">Atendemos não apenas aos grandes players da indústria da <em>moda do Ceará</em>, mas também clientes menores que buscam opções personalizadas.</h3>
            <img data-sal="slide-left" data-sal-delay="200" data-sal-easing="ease-out-circ" data-sal-duration="1200" src={img_2} alt="Amare"/>
          </div>
          <div data-sal="slide-left" data-sal-delay="200" data-sal-easing="ease-out-circ" data-sal-duration="1200"><img src={img_1} alt="Amare"/></div>
        </div>
        <div className={amareStyles.wrapper}>
          <img data-sal="slide-left" data-sal-delay="200" data-sal-easing="ease-out-circ" data-sal-duration="1200" src={img_3} alt="Amare"/>
          <div>
            <div>
              <h3 className="text-md-right pb-5">
              Ao minimizar a produção com a impressão de tecidos em demanda, e adotando <em>tecnologias avançadas</em>, a Amaré se torna mais eficiente e flexível, permitindo a criação de peças únicas e exclusivas de acordo com as preferências dos nossos clientes.
              </h3>
            </div>
            <img data-sal="slide-left" data-sal-delay="200" data-sal-easing="ease-out-circ" data-sal-duration="1200" src={img_4} alt="Amare"/>
          </div>
        </div>
        <h3 className="text-md-center pb-3 pt-5">
        Isso reduz não apenas o <em>impacto ambiental</em>, mas também promove uma <em>moda mais consciente</em>, onde o cliente tem um papel ativo na criação de sua estampa exclusiva, eliminando o excesso de estoque e <em>celebrando a individualidade de cada marca</em>.
        </h3>
        <ContactLink />
      </Container>
      <div className={amareStyles.wrapperHalfs}>
        <div className={amareStyles.firstImg}></div>
        <div className={amareStyles.first}>
          <div data-sal="slide-left" data-sal-delay="800" data-sal-easing="ease-in-out-sine" data-sal-duration="1200" >
            <h1>Feito à mão</h1>
            <p>A Amaré abraça a fusão entre arte e tecnologia, incorporando técnicas de pintura à mão, como a aquarela, para criar estampas únicas e inspiradoras, que ganham ainda mais vida quando digitalizadas para impressão digital. Essa junção entre o artesanal e o digital abre portas para a criação de estampas que são verdadeiras obras de arte, elevando as estampas que entregamos aos nossos clientes.</p>
          </div>
        </div>
        <div className={amareStyles.second}>
          <div data-sal="slide-left" data-sal-delay="800" data-sal-easing="ease-in-out-sine" data-sal-duration="1200">
            <h1>Bases diversas</h1>
            <p>A estamparia oferece um grande leque de possibilidades por meio da ampla variedade tecidos disponíveis para a impressão. Com uma variedade que abrange entre bases de algodão, viscose, linho e muitas outras, bem como tecidos planos e malhas, nossos tecidos de diversas gramaturas podem ser usados para diversas finalidades - da moda praia à alfaiataria, atendemos às necessidades mais exigentes da indústria da moda.</p>
          </div>
        </div>
        <div className={amareStyles.secondImg}></div>
        <div className={amareStyles.thirdImg}></div>
        <div className={amareStyles.third}>
          <div data-sal="slide-left" data-sal-delay="800" data-sal-easing="ease-in-out-sine" data-sal-duration="1200">
            <h1>Estampas exclusivas</h1>
            <p>Nossa estamparia se orgulha em oferecer a exclusividade de estampas, criando designs sob medida para nossos clientes. Inspirados pelas cores vibrantes e rica cultura do Nordeste, nossos designers fundadores possuem experiências de Nova York, trazendo uma perspectiva global e criatividade inovadora para cada projeto. Essa colaboração única resulta em estampas que são verdadeiramente distintas, incorporando a essência do Nordeste com uma pitada de influência cosmopolita.</p>
          </div>
        </div>
      </div>
      <Container>
        <h2 data-sal="slide-left" data-sal-delay="400" data-sal-easing="ease-in-out-sine" data-sal-duration="1200" className="text-md-center pt-5 py-md-5"><em>Cada estampa é uma narrativa única, uma expressão de identidade e um reflexo das experiências pessoais dos nossos designers e dos nossos clientes.</em></h2>
      </Container>
      <Footer />
      <Copyright />
    </React.Fragment>
  )
}